import { apiPortalRh } from './api'

export const integration = async (payload) => {
  try {
    return await apiPortalRh.post(`/integrations/generic`, payload, {})
  } catch (error) {
    return error
  }
}